
/**
 * Created by zhengyf on 2018/6/20.
 */

/**
 * @name dropDownBoxDirective
 * @example
 * <button drop-down-box-directive pop-class="example-class" is-stop-prop-for-list="false" drop-down-group="group"></button>
 * <div class="example-class">下拉菜单</div>
 *
 */

!(function () {

    dropDownBoxDirective.$inject = ['dropDownListService'];
    angular
        .module('app.core')
        .service('dropDownListService', dropDownListService)
        .directive('dropDownBoxDirective', dropDownBoxDirective);

    function dropDownBoxDirective(dropDownListService) {
        return {
            restrict: 'A',
            scope: {
                dropDownGroup: '@', // 下拉菜单类型
                popClass: '@', // 下拉菜单id
                isStopPropForList: '@', // 是否为下拉菜单阻止默认行为
            },
            link: function (scope, element) {
                init();

                element.on('click', function (e) {
                    e.stopPropagation();
                    var
                        id = element.attr('data-drop-down-id'),
                        ele = dropDownListService.getDropDownListById(id)
                    ;
                    hideDropDownList(id);
                    ctrlDropDownListStatus(id, ele);
                });

                angular.element('body').click(function () {
                    hideDropDownList();
                });

                angular.element('.' + scope.popClass).click(function (e) {
                    if (scope.isStopPropForList) {
                        e.stopPropagation();
                    }
                })

                function init() {
                    var info = {
                        dropDownGroup: scope.dropDownGroup,
                        popClass: scope.popClass,
                        isStopPropForList: scope.isStopPropForList,
                        status: 'hide'
                    };

                    var dropDownId = dropDownListService.injectorFn(info);
                    element.attr('data-drop-down-id', dropDownId);
                }

                function hideDropDownList(dropId) {
                    var list = dropDownListService.getAllDropDownList();

                    for(var id in list) {
                        if (list.hasOwnProperty(id) && (id !== dropId)) {
                            dropDownListService.modifyDropDownListStatus(id, 'hide');
                            angular.element('.' + list[id].popClass).hide();
                        }
                    }
                }

                function ctrlDropDownListStatus(id, ele) {
                    if (ele.status === 'hide') {
                        dropDownListService.modifyDropDownListStatus(id, 'show');
                        angular.element('.' + scope.popClass).show();
                    } else {
                        dropDownListService.modifyDropDownListStatus(id, 'hide');
                        angular.element('.' + scope.popClass).hide();
                    }
                }

            }
        }
    }

    function dropDownListService() {

        this.injectors = {};

        this.injectorFn = function (info) {
            var id = getGUID();

            for (var lid in this.injectors) {
                if (this.injectors.hasOwnProperty(lid)) {
                    if (this.injectors[lid].popClass === info.popClass) {
                        return lid;
                    }
                }
            }

            this.injectors[id] = info;
            return id;
        }

        this.getAllDropDownList = function () {
            return this.injectors;
        }

        this.getDropDownListById = function (id) {
            return this.injectors[id];
        }

        this.modifyDropDownListStatus = function (id, status) {
            this.injectors[id].status = status;
        }

        function getGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var
                    d = new Date().getTime(),
                    r = (d + Math.random() * 16) % 16 | 0
                ;
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

    }
    
})();